import React, { useEffect, useState } from "react";
import {
  View,
  Dimensions,
  PixelRatio,
  ActivityIndicator,
  Linking,
  StyleSheet,
  Alert,
} from "react-native";
import PrivilegeSvg from "@components/RaiseTicket/Privilege";
import Text from "@components/AppText";
import Button from "@components/Button";
import { colors } from "@constants/theme";
import { getMyLeader } from "@services/api";
import { connect } from "react-redux";
import ArrowRight from "@assets/svg/ArrowRight";
import analytics from "@services/analytics";
import t from "@constants/localization";
import CityMallLongLogo from "../../assets/svg/CityMallLongLogo";
import { PRIVILEGE_SCREEN } from "../../constants/analyticsEventsCT";

const { width, height } = Dimensions.get("window");
const scale = width / 360;
const PATH = "screens/Auth/Privilege";

function normalize(size) {
  const newSize = size * scale;
  return Math.round(PixelRatio.roundToNearestPixel(newSize));
}

const Privilege = ({ auth: { user }, dispatch }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [leaderInfo, setLeaderInfo] = useState({});
  const { already_a_cx } = user;
  const { already_a_cx_wo_order } = user;

  useEffect(() => {
    analytics.trackEvent(PRIVILEGE_SCREEN.ALREADY_CX);
  }, []);

  useEffect(() => {
    setIsLoading(true);
    getMyLeader()
      .then((res) => {
        setLeaderInfo(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
        setIsLoading(false);
      });
  }, []);

  const handleAlert = () => {
    Alert.alert("", t(`${PATH}/appShareMessage`), [
      { text: t(`${PATH}/OK`), onPress: () => {} },
    ]);
  };

  const handleAppShare = () => {
    try {
      if (leaderInfo && leaderInfo.app_share_link) {
        Linking.openURL(leaderInfo.app_share_link);
      } else {
        Linking.openURL("https://s.ctml.in/mxGetyaYkab");
      }
    } catch (err) {
      handleAlert();
    }
  };

  if (isLoading) {
    return (
      <View style={styles.loadingIndicator}>
        <ActivityIndicator size="large" color={colors.primary} />
      </View>
    );
  } else {
    return (
      <View style={styles.container}>
        <View
          style={{
            padding: 15,
          }}
        >
          <CityMallLongLogo height={30} width={114} />
        </View>
        <View style={styles.cxContainer}>
          <PrivilegeSvg
            height={normalize(134)}
            width={normalize(161)}
            style={{ alignSelf: "center" }}
          />
          {already_a_cx_wo_order ? (
            <Text bold style={styles.alreadyACXText}>
              आप {' " '}
              {leaderInfo && leaderInfo.leader_name} जी के सिटीमॉल स्टोर” के
              कस्टमर है I{" "}
            </Text>
          ) : null}
          {already_a_cx === true && already_a_cx_wo_order === false && (
            <Text style={styles.alreadyACXWO}>
              <Text bold style={styles.alreadyACXWOText}>
                {" "}
                आप “{leaderInfo && leaderInfo.leader_name} जी के सिटीमॉल स्टोर”
                के कस्टमर है I
              </Text>{" "}
            </Text>
          )}
        </View>
        <Button
          btnText="आर्डर करें"
          buttonFontType="bold"
          onPress={handleAppShare}
          fontSize={normalize(18)}
          buttonWidth={width * 0.88}
          height={normalize(50)}
          borderRadius={10}
          IconRight={<ArrowRight style={{ marginLeft: 15 }} />}
          containerStyle={{ alignSelf: "center", marginTop: normalize(56) }}
        />
      </View>
    );
  }
};

const styles = StyleSheet.create({
  loadingIndicator: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  container: { flex: 1 },
  alreadyACXText: {
    fontSize: normalize(20),
    lineHeight: normalize(28),
    alignSelf: "center",
    color: "rgba(0, 0, 0, 0.86)",
    marginTop: normalize(30),
    marginBottom: normalize(10),
    textAlign: "center",
  },
  cxContainer: {
    marginTop: height * 0.2,
    width: width * 0.89,
    alignSelf: "center",
  },
  alreadyACXWO: {
    fontSize: normalize(16),
    lineHeight: normalize(30),
    color: "rgba(0, 0, 0, 0.56)",
    textAlign: "center",
    marginBottom: normalize(10),
    marginTop: normalize(30),
  },
  alreadyACXWOText: {
    fontSize: normalize(20),
    lineHeight: normalize(26),
    color: "rgba(0, 0, 0, 0.86)",
  },
  beALeaderText: {
    color: "rgba(0, 0, 0, 0.56)",
    fontSize: normalize(16),
    lineHeight: normalize(22),
    textAlign: "center",
    width: width * 0.62,
  },
  beALeaderLinkText: {
    color: colors.primary,
    textDecorationLine: "underline",
  },
});

const mstp = ({ auth }) => {
  return {
    auth,
  };
};

export default connect(mstp)(Privilege);
